import { FilterSettings } from "../recoil/filterAtoms";

/**
 * FilterSettings → CSS filter string 변환
 *
 * 사용 예:
 *   <img style={{ filter: toCSSFilter(filterSetting) }} />
 */
export function toCSSFilter(f: FilterSettings): string {
  const parts: string[] = [];

  if (f.brightness !== 0) parts.push(`brightness(${100 + f.brightness}%)`);

  if (f.contrast !== 0) parts.push(`contrast(${100 + f.contrast}%)`);

  if (f.saturate !== 100 && f.saturate !== 0) parts.push(`saturate(${f.saturate}%)`);

  if (f.blur !== 0) parts.push(`blur(${f.blur}px)`);

  return parts.length > 0 ? parts.join(" ") : "none";
}

/**
 * 필터가 기본값(모두 0)인지 확인
 * → true면 filter 속성 자체를 생략해도 됨
 */
export function isFilterActive(f: FilterSettings): boolean {
  return f.brightness !== 0 || f.contrast !== 0 || f.saturate !== 0 || f.blur !== 0;
}
